<div style="display: flex; gap: 1rem;">
  <div class="container">
    <div class="titles-container">
      <div class="fare-title"></div>
      <div class="services-container">
        <div class="service">{{ 'flight.multifamily.seats' | translate }}</div>
        <div class="service">{{ 'flight.multifamily.meal' | translate }}</div>
        <div class="service">{{ 'flight.multifamily.changes' | translate }}</div>
        <div class="service">{{ 'flight.multifamily.refund' | translate }}</div>
        <div class="service">{{ 'flight.multifamily.hand-baggage' | translate }}</div>
        <div class="service">{{ 'flight.multifamily.baggage' | translate }}</div>
      </div>
      <div class="button-container" style="background: none;"></div>
    </div>
    <ng-container *ngFor="let multi of multiFamily.fares; let i = index">
      <div class="fare-container" (click)="touchAndUntouch(multi)"
        [ngClass]="{ touched: multi.touched, '': !multi.touched }">
        <div class="fare-title">
          <span>
            <img src="assets/img/svg/arrow-right.svg" />
            {{ multi.families?.[0]}}
          </span>
          <span *ngIf="multi.families?.[1]">
            <img src="assets/img/svg/arrow-right.svg" style="transform: rotate(180deg);" />
            {{ multi.families?.[1]}}
          </span>
        </div>
        <div class="services-container">
          <div class="indicator" [matTooltip]="seeIndicatorInfo(multi, 'SeatMap')">
            <img [src]="getMultifamilyServiceIcon(multi.services, 'SeatMap')" />
          </div>
          <div class="indicator" [matTooltip]="seeIndicatorInfo(multi, 'Meal')">
            <img [src]="getMultifamilyServiceIcon(multi.services, 'Meal')" />
          </div>
          <div class="indicator" [matTooltip]="seeIndicatorInfo(multi, 'Changes')">
            <img [src]="getMultifamilyServiceIcon(multi.services, 'Changes')" />
          </div>
          <div class="indicator" [matTooltip]="seeIndicatorInfo(multi, 'Refund')">
            <img [src]="getMultifamilyServiceIcon(multi.services, 'Refund')" />
          </div>
          <div class="indicator" [matTooltip]="seeIndicatorInfo(multi, 'HandBaggage')">
            <img [src]="getMultifamilyServiceIcon(multi.services, 'HandBaggage')" />
          </div>
          <div class="indicator" [matTooltip]="seeIndicatorInfo(multi, 'Baggage')">
            <img [src]="getMultifamilyServiceIcon(multi.services, 'Baggage')" />
          </div>
        </div>
        <div class="button-container" (click)="touchAndUntouch(multi)">
          <div
            *ngIf="needsAuthorizationFare(multi)"
            style="display: flex; justify-content: center;">
            <span class="admin-permission-msg">{{ "authorization.permissions-required" | translate }}</span>
          </div>
          <button class="continue-button" (click)="
              emitNextStep(
                multi,
                multi.family
              )
            ">
            <span>{{ "flight.detail-flight.continue-by" | translate }}</span>
            <span>
              {{
              (!company?.showCommissions || isEmployee)
              ? multi.total_price
              : multi.total
              | price }} €
            </span>
          </button>
          <button [ngClass]="{'price-with-auth': needsAuthorizationFare(multi)}" class="buttons"
            (click)="openPolicies(multi)">
            {{ "flight.result-flight.see-politics" | translate }}
          </button>
        </div>
      </div>
    </ng-container>
  </div>
  <div id="price-col">
    <mat-accordion *ngIf="accomInfo" style="margin-top: 1rem;">
      <mat-expansion-panel [expanded]="false">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ "hotel.accom-info" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div *ngIf="accomInfo.needsAuth" style="display: flex; justify-content: center;">
            <span class="admin-permission-msg">{{ "authorization.permissions-required" | translate }}</span>
          </div>
          <div class="room" *ngFor="let room of accomInfo.selectedRooms; let j = index">
            <p style="font-weight: 600;">{{ "hotel.room" | translate}} {{j + 1}}: {{room.name}}</p>
            <div class="total-price base-price" *ngIf="room.rates[0].price && accomInfo.hotel.code.charAt(0) !== 'E'">
              <p>{{ "hotel.base-rate" | translate }}: </p>
              <p>{{ room.rates[0].price.totalPrice.total | price }}€</p>
            </div>
            <div class="total-price base-price" *ngIf="room.rates[0].price && accomInfo.hotel.code.charAt(0) !== 'E'">
              <p *ngIf="room.rates[0].price.fees && room.rates[0].price.fees.amount > 0" style="color: #f46f69"
                matTooltip="{{ 'hotel.due-at-property-details' |translate }}">{{
                "hotel.due-at-property" | translate }} <i class="fa fa-question-circle"></i>: </p>
              <p>{{room.rates[0].price.fees.amount | price }}€</p>
            </div>
            <div class="total-price base-price" *ngIf="room.rates[0].price && accomInfo.hotel.code.charAt(0) === 'E'">
              <p *ngIf="room.rates[0].price.baseRate && room.rates[0].price.baseRate.amount > 0">{{
                "hotel.base-rate" | translate }}: </p>
              <p>{{ room.rates[0].price.baseRate.amount | price }}€</p>
            </div>
            <div class="total-price base-price"
              *ngIf="room.rates[0].price.taxAndServiceFee && room.rates[0].price.taxAndServiceFee.amount > 0">
              <p matTooltip="{{ 'hotel.taxes-and-fees-details' |translate }}">{{ "hotel.taxes-and-fees" |
                translate }} <i class="fa fa-question-circle"></i>: </p>
              <p>{{ room.rates[0].price.taxAndServiceFee.amount | price }}€</p>
            </div>
            <div class="total-price base-price"
              *ngIf="room.rates[0].price.salesTax && room.rates[0].price.salesTax.amount > 0">
              <p>{{
                "hotel.sales-tax" | translate }}: </p>
              <p>{{ room.rates[0].price.salesTax.amount | price }}€</p>
            </div>
            <div class="total-price base-price" *ngIf="room.rates[0].price.fees && room.rates[0].price.fees.amount > 0">
              <p style="color: #f46f69" matTooltip="{{ 'hotel.due-at-property-details' |translate }}">{{
                "hotel.due-at-property" | translate }} <i class="fa fa-question-circle"></i>: </p>
              <p>{{ room.rates[0].price.fees.amount | price }}€</p>
            </div>
            <div class="total-price base-price" *ngIf="room.rates[0].price && room.rates[0].price.totalPrice.total">
              <p>{{ "search.search-booked.total-price-by-room" | translate }}: </p>
              <p>{{ room.rates[0].price.totalPrice.total | price }}€</p>
            </div>
          </div>
          <div class="total-price total-price-label">
            <p>{{ "search.search-booked.total-price" | translate }}: </p>
            <p>{{ getTotalPriceAccom() | price }}€</p>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <div class="total-price total-price-label" *ngIf="accomInfo">
      <p>{{ "hotel.total-price-package" | translate }}: </p>
      <p>{{ getTotalPackage() | price }} €</p>
    </div>
  </div>
</div>